// 洞一科技官网Mock数据系统
// 为演示准备的真实感数据

// API模拟延迟
export const mockDelay = (ms = 300) => new Promise(resolve => setTimeout(resolve, ms));

// Mock API 响应格式
export const createMockResponse = (data, success = true, message = 'success') => ({
  success,
  message,
  data,
  timestamp: new Date().toISOString()
});

// 核心业务数据（基于洞一科技真实业务架构）
export const coreBusinessData = {
  // 三大核心业务板块
  businessLines: [
    {
      id: 1,
      name: '卫星销售',
      subtitle: 'DY平台+载荷定制',
      revenueTarget: '40%',
      icon: 'am-icon-rocket',
      description: '提供DY系列卫星平台和定制化载荷解决方案',
      keyProducts: [
        'DY50平台（对地遥感+窄带通信）',
        'DY300平台（0.5米分辨率SAR）',
        '碳监测专项载荷',
        'SAR遥感载荷'
      ],
      targetCustomers: ['省级环保部门', '能源集团', '科研院所', '高校'],
      technicalSpecs: {
        platform: 'DY50/DY300系列',
        resolution: '0.5-10米可选',
        orbit: 'LEO 400-800km',
        lifespan: '3-5年'
      },
      applications: [
        '环境监测', '资源勘探', '灾害预警', '农业监测'
      ],
      advantages: [
        '成本较体制内低40%',
        '技术成熟可靠',
        '快速交付能力',
        '定制化服务'
      ]
    },
    {
      id: 2,
      name: '数据服务',
      subtitle: '碳排放监测SaaS',
      revenueTarget: '50%',
      icon: 'am-icon-leaf',
      description: '基于卫星数据的碳排放监测和分析服务平台',
      keyProducts: [
        '碳排放监测SaaS平台',
        '温室气体监测服务',
        '灾害预警服务',
        '期货数据交易'
      ],
      targetCustomers: ['期货交易所', '碳交易机构', '环保部门', '企业用户'],
      technicalSpecs: {
        precision: 'CO₂ 1-2ppm，CH₄ 15-20ppb',
        coverage: '全球覆盖',
        updateFreq: '日更新',
        dataFormat: 'API/报告/可视化'
      },
      applications: [
        '碳交易数据支撑', '煤矿甲烷泄露监测', '企业碳核查', '政策制定支持'
      ],
      advantages: [
        '全球首商业级精度',
        '实时数据更新',
        '标准化API接口',
        '专业分析报告'
      ]
    },
    {
      id: 3,
      name: '系统集成',
      subtitle: '天地一体化解决方案',
      revenueTarget: '10%',
      icon: 'am-icon-cogs',
      description: '提供完整的天地一体化系统集成解决方案',
      keyProducts: [
        '电网防灾系统',
        '环保监测系统',
        '应急管理系统',
        '智慧城市解决方案'
      ],
      targetCustomers: ['国家电网', '应急管理部', '地方政府', '大型企业'],
      technicalSpecs: {
        integration: '卫星+地面+应用',
        response: '准实时响应',
        scalability: '模块化扩展',
        reliability: '99.9%可用性'
      },
      applications: [
        '电力线路监测', '自然灾害预警', '环境质量监控', '应急指挥调度'
      ],
      advantages: [
        '天地一体化架构',
        '模块化设计',
        '快速部署',
        '专业运维支持'
      ]
    }
  ],

  // 核心技术能力
  coreTechnologies: [
    {
      id: 1,
      name: '整星机电热一体化设计',
      description: '自主研发的卫星平台设计技术',
      level: '国际先进',
      applications: ['DY50平台', 'DY300平台']
    },
    {
      id: 2,
      name: '软件化姿轨控系统',
      description: '精度0.05°的高精度姿态控制技术',
      level: '国际领先',
      applications: ['卫星姿态控制', '轨道维持']
    },
    {
      id: 3,
      name: '自适应空间分辨外差干涉光谱技术',
      description: '碳监测卫星核心载荷技术',
      level: '国际领先',
      applications: ['CO₂监测', 'CH₄监测']
    }
  ],

  // 制造能力
  manufacturingCapability: {
    annualCapacity: 100,
    baseLocation: '台州卫星联合制造基地',
    productionLine: '自动化生产线',
    qualitySystem: '完备质量体系',
    deliveryTime: '6-12个月'
  }
};

// 产品信息数据
export const productData = {
  // 产品分类
  categories: [
    { id: 1, name: '卫星平台', icon: 'am-icon-rocket', typeId: 1 }
  ],
  
  // 产品列表
  products: [
    // DY系列卫星平台
    {
      id: 1,
      typeId: 1,
      typeDetaisId: 1,
      title: 'DY50卫星平台',
      imageUrl1: '/src/assets/images/product/dy50-platform.jpg',
      description: 'DY50平台是洞一科技主力产品，集成对地遥感与窄带通信能力',
      specifications: {
        mass: '50kg级',
        power: '200W+',
        resolution: '1-5米',
        orbit: 'LEO 500-700km',
        lifespan: '3年+',
        communication: '窄带通信'
      },
      applications: ['环境监测', '农业遥感', '灾害监测', '资源调查'],
      status: '成熟产品',
      price: '面议'
    },
    {
      id: 2,
      typeId: 1,
      typeDetaisId: 2,
      title: 'DY300卫星平台',
      imageUrl1: '/src/assets/images/product/dy300-platform.jpg',
      description: 'DY300平台支持高分多模综合遥感，配备0.5米分辨率SAR载荷',
      specifications: {
        mass: '300kg级',
        power: '500W+',
        resolution: '0.5米SAR',
        orbit: 'LEO 600-800km',
        lifespan: '5年+',
        payload: '多模综合遥感'
      },
      applications: ['高精度遥感', '地表变化监测', '城市规划', '精准农业'],
      status: '在研阶段',
      price: '面议'
    },
    
    // 数据服务平台
    {
      id: 4,
      typeId: 3,
      typeDetaisId: 4,
      title: '碳排放监测SaaS平台',
      imageUrl1: '/src/assets/images/product/carbon-saas.jpg',
      description: '基于卫星数据的碳排放监测和分析服务平台',
      specifications: {
        dataType: '碳排放数据',
        updateFreq: '日更新',
        coverage: '全球覆盖',
        api: 'RESTful API',
        dashboard: 'Web可视化',
        report: '专业分析报告'
      },
      applications: ['碳交易', '环保监管', '企业碳核查', '政策制定'],
      status: '商业运营',
      price: '订阅制'
    },
    
    // 系统集成方案
    {
      id: 5,
      typeId: 4,
      typeDetaisId: 5,
      title: '天地一体化监测系统',
      imageUrl1: '/src/assets/images/product/integrated-system.jpg',
      description: '完整的天地一体化环境监测解决方案',
      specifications: {
        architecture: '天地一体化',
        components: '卫星+地面+应用',
        response: '准实时',
        scalability: '模块化扩展',
        deployment: '云端部署',
        support: '7×24服务'
      },
      applications: ['电网防灾', '环保监测', '应急管理', '智慧城市'],
      status: '解决方案',
      price: '项目制'
    }
  ]
};

// 新闻文章数据
export const newsData = {
  categories: [
    { id: 1, name: '公司新闻' },
    { id: 2, name: '行业动态' },
    { id: 3, name: '技术突破' },
    { id: 4, name: '合作伙伴' }
  ],
  
  articles: [
    {
      id: 1,
      categoryId: 4,
      title: '洞源科技与洲际航天达成阿布扎比航天城项目合作',
      summary: '上海洞源科技有限公司与洲际航天科技集团达成一致，将在阿布扎比航天城项目中合作，共同推进海外业务的发展。双方拟在阿布扎比航天生态城成立合资公司，在航天器设计制造、数据应用、航天资源开发等方面开展合作。',
      content: `上海洞源科技有限公司(简称:洞源科技)是国内领先的卫星设计和制造商,洲际航天科技集团(简称:洲际航天)是面向海外的商业航天企业,双方达成一致,将在阿布扎比航天城项目中合作,共同推进海外业务的发展。

近日,双方拟在阿布扎比航天生态城成立合资公司,在航天器设计制造、数据应用、航天资源开发等方面开展合作。洞源科技国际领先的碳监测星座和SAR卫星星座开发和应用的商业航天科技企业,致力于在全球范围开展碳监测星座和SAR卫星星座的应用落地和商业化。洲际航天是总部位於阿联酋迪拜及中国香港的商业航天公司,并于2018年8月16日在香港联合交易所有限公司(香港联交所)主板上市,股票代号:1725.HK。

双方的合作将在阿布扎比航天城落地,此航天城项目占地约300万平米,汇集了产业生态链的全部公司,并将逐步拓展为囊括新材料、新能源、贸易、物流、金融等多位一体的国际化商业航天平台和全新的生态系统,以航天科技智慧集群与创造力贡献社会价值。

双方将成立合资公司,共同开发国际航天市场,发挥企业集群优势,共同推进商业航天的发展和壮大,同时也期待与各行业跨界创新,共同推进中国行业航天企业的国际化之路。`,
      imageUrl: require('@/assets/images/news/news1/news1.png'),
      publishTime: '2024-03-21T10:00:00Z',
      author: '洞源科技',
      views: 1520,
      isTop: true
    },
    {
      id: 2,
      categoryId: 1,
      title: '洞一科技成功加入科创版企业上市培育库',
      summary: '浙江洞一科技有限公司传来好消息，已成功加入科创版企业上市培育库。这一举措不仅标志着洞一科技在科技创新领域取得了新的突破，也预示着在未来资本市场上的发展前景更加广阔。',
      content: `近日，本公司浙江洞一科技有限公司传来好消息，已成功加入科创版企业上市培育库。这一举措不仅标志着洞一科技在科技创新领域取得了新的突破，也预示着在未来资本市场上的发展前景更加广阔。

2024 年 11 月，本公司成功加入"科创企业上市培育库"这不仅是发展历程中的重要里程碑，更是为未来的发展奠定了坚实的基础。科创版培育库由上海市科学技术委员会、金融工作局指导，上海市科技创业中心实施建设。其旨在支持新技术、新产业、新业态发展，为优质科技企业提供上市前服务，培育代表性科创企业，实现技术效能提升，助力企业成长加速。我司当前轮次为天使轮，在科创版培育库 A 级为最高级别，企业可具备辅导期，在排队过程中可优先上市。

洞一科技是一家主要从事卫星设计、研制、测试、运营和应用的商业航天企业。为客户提供卫星设计、制造、发射和地面测控等一条龙服务，实现卫星整星的在轨交付。洞一科技汇聚了一批航天领域的资深专家，多位团队成员参与过风云、北斗、火星探测器等国家重大卫星工程，担任过型号总设计师、总指挥等重要职务；获得过国家科技进步二等奖、国防一等奖等奖项，形成了在卫星遥感方面非常具有竞争优势的核心能力。

在加入上市培育库后，洞一科技能够得到更为广阔的融资渠道，还助力优化了治理结构，明确创新发展规划。同时，借助培育库内丰富的科技、金融资源，洞一科技得以加速技术创新和市场拓展，显著提升了企业的核心竞争力和市场地位。在未来，洞一科技将继续加大科技研发投入，不断提升自身的技术实力和创新能力。`,
      imageUrl: require('@/assets/images/news/news2/news2.png'),
      publishTime: '2024-11-01T14:30:00Z',
      author: '洞一科技',
      views: 980,
      isTop: true
    },
    {
      id: 3,
      categoryId: 1,
      title: '传承科技基因，筑梦航天未来 - 洞一科技举办暑期实践活动',
      summary: '7月7日，一场充满科技魅力与统战温情的暑期实践活动在宁波市北仑区展开。知联会小港分会联合浃江青蓝会精心策划的"传承科技基因，筑梦航天未来"活动，吸引了60名小学生走进会员企业洞一科技。',
      content: `传承科技基因，筑梦航天未来 

7月7日，一场充满科技魅力与统战温情的暑期实践活动在宁波市北仑区展开。知联会小港分会联合浃江青蓝会精心策划的"传承科技基因，筑梦航天未来"活动，吸引了60名小学生走进会员企业洞一科技。此次活动不仅是一场别开生面的科技探索之旅，更是统一战线凝聚力量、培育新时代少年接班人的生动实践。

活动伊始，浃江青蓝会会员张银山化身"科技导游"，带领孩子们踏入航天科普展厅。

展厅内，卫星模型、精密的航天仪器陈列有序，仿佛在诉说着中国航天的辉煌历程。企业负责人现场亲自演示卫星零部件制造工艺，以"北斗导航"系统的研发突破、民营航天企业的崛起等鲜活案例，深入浅出地展现民营企业在科技创新浪潮中的关键作用。

"作为北仑年轻一代统战品牌，浃江青蓝会始终秉持传承与创新的理念，我们开放企业平台，就是希望让孩子们直观感受中国科技发展进程中民营企业贡献的力量，在他们心中播下追逐星辰大海的种子，激励他们未来成为科技创新的接班人。"浃江青蓝会会员、洞一科技负责人章英杰满怀期许地说道。

活动特别邀请到浙江红船精神优秀五老宣讲员、退伍老兵陈伟高同志带来《童心同行向未来》主题宣讲。

陈伟高用朴实而真挚的语言，生动讲述了战争年代的艰苦和如今日新月异的中国，从一张老照片说起，分享宁波这几十年来的日月变迁，每一个细节都让孩子们深刻体会到科技报国之路的重要性。陈伟高深情勉励孩子们："既要仰望星空，树立远大理想，也要脚踏实地，勤奋学习知识，未来成为建设祖国的栋梁之才。"

宣讲过程中，孩子们全神贯注，被一个个故事深深吸引，在互动环节踊跃提问，现场气氛热烈，掌声此起彼伏。新四年级学生小王难掩激动之情："原来这些高科技成果背后凝聚着这么多前辈的心血和付出，我一定要像陈爷爷说的那样，努力学习，做有理想、有担当的新时代少年！"

此次活动创新采用"实地参观 + 先进宣讲"的形式，将科技教育与统战思想教育有机融合。孩子们在近距离接触前沿科技、感受科技魅力的同时，也深刻体会到统一战线汇聚各方力量、服务社会发展的时代活力。知联会小港分会与浃江青蓝会作为统战社会组织充分发挥自身优势，整合资源，为青少年搭建起了解科技、热爱科学的平台，引导他们树立正确的价值观和远大的理想抱负。

少年强则国强，少年智则国智。培养新时代科技人才，关乎国家的未来和民族的希望。知联会与浃江青蓝会负责人分别表示，未来将持续深化践行"凝心聚力"的理念，进一步发挥统一战线联系广泛、智力密集的优势，开展更多形式多样、富有意义的活动，将传承的火种传递给更多青少年，为培养担当民族复兴大任的中国少年接班人贡献坚实的统战力量，在新时代的征程中书写统战社会组织助力教育事业发展的崭新篇章。`,
      imageUrl: require('@/assets/images/news/news3/news3.png'),
      publishTime: '2025-07-08T09:15:00Z',
      author: '洞一科技',
      views: 756,
      isTop: false
    },
    {
      id: 4,
      categoryId: 1,
      title: '浙江洞一科技有限公司：逐梦星河 砺剑长空',
      summary: '科技浙江栏目报道浙江洞一科技有限公司，逐梦星河，砺剑长空，展现商业航天创新力量。',
      content: `[SUBTITLE]逐梦星河 砺剑长空[/SUBTITLE]

[IMG1]

作为国家高新技术企业，浙江洞一科技有限公司专注于提供卫星设计、研制到在轨交付的全链条服务，拥有星载及军民两用铷原子钟全国独家代理权，并被授牌为高校实习基地，持续书写商业航天新未来。

[IMG2]

[QUOTE]浙江洞一科技有限公司创始人
章英杰[/QUOTE]

我大学毕业以后怀揣着探索星辰大海的梦想，来到了我们航天八院的卫星总体所，从事航天工作已经25年了，在这个过程中，干过了国家很多的型号，有风云一号第一代极轨气象卫星，风云三号第二代极轨气象卫星，以及我们国家的第一个火星探测器。所以想把这个航天的掌握的知识和航天的技能，在商业航天这个赛道上结合资本的力量，打造研制出高质量、低成本、长寿命的卫星，从太空的视角来见证万事万物的变迁。

[IMG3]

这份跨越星海的理想背后是一支专业的实干团队，公司卫星团队汇聚20余位顶尖高校博士、硕士，核心成员曾担任北斗、风云、火星探测等国家重大工程的总师或专家顾问，主导完成十余项创新成果，获多项国家级与省部级科技奖项，以深厚积淀奠定行业领军地位。

[IMG4]

[QUOTE]浙江洞一科技有限公司总体技术负责人
朱欣祎[/QUOTE]

公司正在研制的卫星是一颗高精度碳源监测卫星，星上配置了一台高光谱成像载荷，应用领域包括环境监测、探矿找矿，可解决碳源溯源这个痛点问题。目前，技术指标达到了国际先进水平。

[IMG5]

探索无限宇宙，洞察万物起源。浙江洞一科技有限公司，正以坚定步伐迈向世界一流航天企业的宏伟征程。

（本文原载于微信公众号「了不起的家乡」，<a href="https://mp.weixin.qq.com/s/1Y1BjlU_KFJ9_mJUUpKoNw?scene=1" target="_blank" rel="noopener noreferrer">阅读原文</a>）`,
      imageUrl: require('@/assets/images/news/news4/image-title.png'),
      publishTime: '2026-02-02T14:39:00Z',
      author: '洞一科技',
      views: 0,
      isTop: false
    },
    {
      id: 5,
      categoryId: 1,
      title: '洞一科技发布洞源星座项目 开创「卫星+碳数据服务」商业模式',
      summary: '2月1日，浙江洞一科技有限公司发布洞源星座项目，规划发射28颗碳监测卫星，融合光学与SAR双载荷，提供全球温室气体监测与碳数据一站式服务，率先开创「卫星+碳数据服务」商业模式。',
      content: `本文转载自上海证券报·中国证券网，原标题：《洞一科技发布洞源星座项目 开创「卫星+碳数据服务」商业模式》。

上证报中国证券网讯(记者刘怡鹤)2月1日，浙江洞一科技有限公司（以下简称「洞一科技」）发布洞源星座项目。洞源星座规划发射由28颗卫星组成的碳监测星座体系，其中包括7颗碳源监测卫星与21颗碳汇监测卫星。洞一科技全面负责星座系统规划、设计、研制和运营。

洞源星座创新融合光学遥感与SAR遥感双载荷，具备对二氧化碳、甲烷等温室气体的高精度监测与溯源能力，同时可实现对森林、植被等碳汇资源的动态跟踪。星座可提供覆盖全球、自主可控、高频更新的温室气体分布数据，全面提升我国在温室气体监测、评估与核查方面的能力。

洞一科技以「低成本、高性能」为平台研制理念，依托自主可控的卫星平台技术、遥感数据处理与碳反演算法，可提供从卫星数据获取、温室气体浓度反演、排放源识别定位到动态监测报告的一站式碳数据服务，不仅拓宽了商业航天在环境监测、能源勘查、应急管理等领域的应用场景，更率先开创了「卫星+碳数据服务」的商业模式。

碳源监测卫星应用包含探矿/找矿、监测水污染和水质、监测土壤污染及环境；碳汇监测卫星应用包含获取各种天气条件下的图像数据、监测地表形变以及沉降数据等。

按照部署计划，洞源星座将在2026年发射第一颗碳源监测卫星；2027年发射第一颗碳汇监测卫星；2028年发射一轨洞源卫星；2030年之前完成星座部署。

洞一科技创办于2022年8月，分别在浙江宁波北仑、上海闵行航天城和陕西西安设立了研发基地与实验室。洞一科技集卫星设计、研制、测试、运营及应用于一体，确保卫星整星的在轨交付。公司汇聚航天领域资深卫星专家和遥感应用专家，多位团队成员参与过北斗、风云、火星探测器等国家重大卫星工程，担任总设计师、总指挥等重要职务。

（原文链接：<a href="https://news.10jqka.com.cn/20260202/c674480019.shtml" target="_blank" rel="noopener noreferrer">上海证券报·中国证券网</a>）`,
      imageUrl: require('@/assets/images/news/news5/tan.png'),
      publishTime: '2026-02-02T15:55:00Z',
      author: '洞一科技',
      views: 0,
      isTop: true
    },
    {
      id: 6,
      categoryId: 1,
      title: '洞源星座上海重磅发布！浙江洞一科技集结顶尖智慧，领航双碳航天新赛道',
      summary: '2026年2月1日，浙江洞一科技有限公司在上海正式发布「洞源星座（DY-1）」，以「锚定双碳」为核心使命，规划28颗卫星规模化组网，为国家2030碳达峰、2060碳中和目标提供航天级解决方案。多位权威专家受聘高级顾问，为星座技术研发与商业化运营注入智慧动力。',
      content: `2026年2月1日，浙江洞一科技有限公司在上海正式发布「洞源星座（DY-1）」，这一以「锚定双碳」为核心使命的遥感星座，凭借28颗卫星的规模化组网规划与精准监测能力，为国家「2030碳达峰、2060碳中和」目标提供了航天级解决方案。发布会现场，来自航天技术、行业应用、资本等领域的权威专家齐聚，通过主题演讲深度解析星座价值，多位专家正式受聘成为公司高级顾问，为洞源星座的技术研发与商业化运营注入强劲智慧动力。

作为本次发布会的核心亮点，洞源星座的战略规划与技术优势引发广泛关注。据介绍，该星座由7颗碳源监测卫星与21颗碳汇监测卫星组成，将分三期完成组网：2026年底首颗碳源监测卫星发射，聚焦全球主要碳排放点识别监测；2027年底碳汇监测卫星跟进，瞄准我国碳汇资源普查；2030年前实现全球碳源汇近实时监测，真正让温室气体「可测量、可报告、可核查」。卫星搭载的高光谱成像载荷与X频段SAR载荷，具备高分辨率、高精度探测等优势，技术指标达到国际先进水平。

发布会主题演讲环节，来自不同领域的专家们从不同维度为星座发展建言献策。资本领域专家围绕商业航天产业投资趋势、星座规模化建设的融资路径展开分析，强调洞源星座作为双碳赛道的稀缺航天项目，有望成为资本关注的焦点；载荷技术专家深入解读了碳监测载荷的核心技术突破，详解高光谱分辨率与SAR载荷穿透式观测的技术原理与应用价值；应用与运营专家则结合国土资源、精准农业、智慧城市等场景，阐述了星座数据服务的商业化前景，为星座构建完整生态链提供了新思路。

为进一步强化技术研发与战略决策能力，浙江洞一科技在现场举行高级顾问聘任仪式，聘请多位航天技术、商业运营领域的顶尖专家加盟。此次受聘的专家团队均具备深厚的行业积淀与丰富的实践经验，未来将为洞源星座的载荷优化、组网规划等关键环节提供专业指导，助力公司在商业航天与双碳产业的交叉领域实现高质量发展。

浙江洞一科技相关负责人表示，洞源星座的发布是公司践行「航天赋能绿色发展」使命的重要一步，此次专家团队的加盟与各方智慧的汇聚，将为星座建设注入强大动力。未来，公司将以洞源星座为核心，推动航天技术与双碳产业深度融合，为全球气候治理提供中国方案与中国力量。

（本文来源：<a href="http://fashion.ce.cn/xx/202602/t20260206_2757836.shtml" target="_blank" rel="noopener noreferrer">中国经济网</a>，来源：鲁网）`,
      imageUrl: require('@/assets/images/news/news6/image1.jpg'),
      publishTime: '2026-02-06T09:03:00Z',
      author: '洞一科技',
      views: 0,
      isTop: true
    }
    ,
    {
      id: 7,
      categoryId: 2,
      title: '产业风口 | 为何卫星申请规模屡创新高？',
      summary: '10万颗、20万颗、100万颗……这些数字不是天上星星的数量，而是全球计划发射的卫星数量。',
      content: `10万颗、20万颗、100万颗……这些数字不是天上星星的数量，而是全球计划发射的卫星数量。

尽管这些数量级的卫星大多仍处于申报阶段，但却一次次刷新了人们对商业航天产业的认识和想象。为何卫星部署规模呈现爆发式增长？近地轨道空间能否容纳？从普通人的生活到地球生态，大量卫星的布局又将带来哪些改变？

记者采访专家了解到，在大国竞相锁定太空资源和卫星技术普及化趋势下，大规模卫星申报和部署成为必然趋势，奠定广阔卫星应用的基础。未来，“+卫星”“卫星+”将如同“互联网+”“+互联网”，培育出繁荣的服务生态。专家们表示，在部署更多卫星的同时，既要打通卫星应用“最后一公里”的商业化堵点，也要关注由此带来的一系列挑战。

策划：刘雪 邱江

作者：刘怡鹤 陈颖清

上海证券报出品

（原文链接：<a href="https://h.xinhuaxmt.com/vh512/share/12961314?docid=12961314&newstype=1001&d=135256f&channel=weixin&time=1770611525815" target="_blank" rel="noopener noreferrer">新华社客户端</a>）`,
      imageUrl: require('@/assets/images/news/news7/image.png'),
      publishTime: '2026-02-07T00:00:00Z',
      author: '新华社',
      views: 0,
      isTop: false
    }
  ]
};

// 客户案例数据
export const exampleData = {
  categories: [
    { id: 0, name: '双碳大脑应用平台', icon: 'am-icon-map-o' },
    { id: 1, name: '温室气体检测平台', icon: 'am-icon-scribd' },
    { id: 2, name: '智慧城市应用', icon: 'am-icon-building-o' },
    { id: 3, name: '精准农业解决方案', icon: 'am-icon-leaf' }
  ],
  
  cases: [
    {
      exampleType: 0,
      id: 1,
      title: '双碳大脑应用平台',
      client: '某省生态环境厅',
      duration: '2023年6月 - 2024年6月',
      background: '为响应国家双碳目标，该省需要建立碳排放监测与管理平台',
      solution: '基于洞一科技卫星数据，构建省级碳排放监测体系',
      results: '实现全省碳排放精准监测，为政策制定提供科学依据',
      images: {
        image1: '/src/assets/images/example/carbon-platform-1.jpg',
        image2: '/src/assets/images/example/carbon-platform-2.jpg',
        image3: '/src/assets/images/example/carbon-platform-3.jpg',
        image4: '/src/assets/images/example/carbon-platform-4.jpg',
        image5: '/src/assets/images/example/carbon-platform-5.jpg'
      },
      feedback: '该平台为我省双碳工作提供了强有力的技术支撑，监测精度和时效性都达到了国际先进水平。'
    },
    {
      exampleType: 1,
      id: 2,
      title: '温室气体检测平台',
      client: '国家气候中心',
      duration: '2023年1月 - 2024年3月',
      background: '建立全国温室气体监测网络，提升气候变化监测能力',
      solution: '利用卫星遥感技术，建立温室气体监测与分析系统',
      results: '实现CO2、CH4等温室气体的高精度监测和预警',
      images: {
        image1: '/src/assets/images/example/ghg-platform-1.jpg',
        image2: '/src/assets/images/example/ghg-platform-2.jpg',
        image3: '/src/assets/images/example/ghg-platform-3.jpg',
        image4: '/src/assets/images/example/ghg-platform-4.jpg'
      },
      feedback: '系统运行稳定，数据质量优秀，为国家气候政策制定提供了重要技术支撑。'
    }
  ]
};

// 团队成员数据
export const teamData = {
  leadership: [
    {
      id: 1,
      name: '张明华',
      position: '创始人兼CEO',
      education: '清华大学航天工程博士',
      experience: '20年航天系统工作经验，曾参与多个国家重大航天项目',
      photo: '/src/assets/images/team/ceo.jpg',
      description: '专注于商业航天战略规划和产业化发展'
    },
    {
      id: 2,
      name: '李建国',
      position: '技术总监',
      education: '北航卫星工程硕士',
      experience: '15年卫星设计经验，获得多项技术专利',
      photo: '/src/assets/images/team/cto.jpg',
      description: '负责卫星平台技术研发和系统架构设计'
    },
    {
      id: 3,
      name: '王芳',
      position: '运营总监',
      education: '上海交大工商管理硕士',
      experience: '12年航天产业运营管理经验',
      photo: '/src/assets/images/team/coo.jpg',
      description: '负责公司日常运营和项目管理'
    }
  ],
  
  experts: [
    {
      id: 4,
      name: '赵卫星',
      position: '首席卫星专家',
      speciality: '卫星总体设计',
      experience: '18年',
      projects: 15
    },
    {
      id: 5,
      name: '孙测控',
      position: '测控技术专家',
      speciality: '地面测控系统',
      experience: '16年',
      projects: 12
    },
    {
      id: 6,
      name: '周数据',
      position: '数据处理专家',
      speciality: '卫星数据处理',
      experience: '14年',
      projects: 20
    }
  ]
};

// 企业资质数据
export const qualificationData = {
  certificates: [
    {
      id: 1,
      name: 'ISO9001质量管理体系认证',
      issuer: '中国质量认证中心',
      date: '2023-06-15',
      validUntil: '2026-06-14',
      image: '/src/assets/images/certificates/iso9001.jpg'
    },
    {
      id: 2,
      name: '军工保密资格认证',
      issuer: '国家保密局',
      date: '2023-08-20',
      validUntil: '2026-08-19',
      image: '/src/assets/images/certificates/security.jpg'
    },
    {
      id: 3,
      name: '高新技术企业认证',
      issuer: '浙江省科技厅',
      date: '2023-12-01',
      validUntil: '2026-11-30',
      image: '/src/assets/images/certificates/hightech.jpg'
    }
  ],
  
  patents: [
    {
      id: 1,
      title: '一种微纳卫星平台设计方法',
      type: '发明专利',
      number: 'ZL202310123456.7',
      date: '2023-05-15'
    },
    {
      id: 2,
      title: '卫星数字孪生系统及方法',
      type: '发明专利',
      number: 'ZL202310789012.3',
      date: '2023-09-20'
    },
    {
      id: 3,
      title: '卫星测控数据处理算法',
      type: '软件著作权',
      number: '2023SR0456789',
      date: '2023-11-10'
    }
  ],
  
  awards: [
    {
      id: 1,
      name: '2023年度浙江省科技进步奖',
      level: '省级',
      date: '2023-12-20'
    },
    {
      id: 2,
      name: '中国商业航天创新奖',
      level: '行业',
      date: '2023-10-15'
    }
  ]
};

// 技术参数数据
export const technicalData = {
  satellites: [
    {
      id: 1,
      name: 'DY-100',
      type: '微纳卫星',
      mass: 45,
      power: 120,
      orbit: 500,
      lifespan: 3,
      payload: 15
    },
    {
      id: 2,
      name: 'DY-200',
      type: '小卫星',
      mass: 150,
      power: 300,
      orbit: 700,
      lifespan: 5,
      payload: 50
    }
  ],
  
  groundStations: [
    {
      id: 1,
      name: '宁波测控站',
      location: '浙江宁波',
      antennaSize: '7.3m',
      frequency: 'S/X频段',
      trackingAccuracy: '±0.1°'
    },
    {
      id: 2,
      name: '北京控制中心',
      location: '北京海淀',
      antennaSize: '12m',
      frequency: 'S/X/Ka频段',
      trackingAccuracy: '±0.05°'
    }
  ]
};

// 卫星轨道数据（TLE格式）
export const satelliteOrbitData = {
  constellation: [
    // DY50系列 - 前3颗卫星
    {
      id: 1,
      name: 'DY50-01',
      tle: [
        'DY50-01',
        '1 39150U 13018A   25201.20398705  .00000453  00000-0  72344-4 0  9991',
        '2 39150  97.9485 274.2929 0016100 253.9739 105.9698 14.76508204659299'
      ],
      status: 'active',
      launchDate: '2024-01-15'
    },
    {
      id: 2,
      name: 'DY50-02',
      tle: [
        'DY50-02',
        '1 40118U 14049A   25201.14858654  .00000703  00000-0  98690-4 0  9999',
        '2 40118  98.0576 259.9233 0003955 202.3164 157.7877 14.80579941590110'
      ],
      status: 'active',
      launchDate: '2024-03-20'
    },
    {
      id: 3,
      name: 'DY50-03',
      tle: [
        'DY50-03',
        '1 43484U 18048A   25201.02283796  .00000539  00000-0  84163-4 0  9994',
        '2 43484  97.8214 270.0078 0013183 162.0521 198.1157 14.76605044384377'
      ],
      status: 'active',
      launchDate: '2024-06-15'
    }
  ],
  
  coverage: {
    globalCoverage: 85,
    revisitTime: 12,
    resolution: 1.0,
    swathWidth: 15
  }
};

// 首页轮播数据
export const slideshowData = [
  {
    id: 1,
    title: '洞察万物起源',
    subtitle: '洞一科技 - 商业航天领域的创新者',
    image: '/src/assets/images/index/slideshow-1.jpg',
    link: '/about'
  },
  {
    id: 2,
    title: '卫星制造与运营专家',
    subtitle: '提供从设计到运营的一站式解决方案',
    image: '/src/assets/images/index/slideshow-2.jpg',
    link: '/product'
  },
  {
    id: 3,
    title: '数字孪生卫星技术',
    subtitle: '引领卫星智能化运营新时代',
    image: '/src/assets/images/index/slideshow-3.jpg',
    link: '/technology'
  }
];

// 服务数据
export const serviceData = {
  services: [
    {
      id: 1,
      icon: 'am-icon-rocket',
      title: '卫星设计服务',
      description: '提供卫星总体设计、分系统设计等专业服务',
      features: [
        '整星机电热一体化设计',
        '载荷集成与优化设计',
        '卫星平台标准化设计',
        '可靠性分析与验证'
      ]
    },
    {
      id: 2,
      icon: 'am-icon-cogs',
      title: '制造集成服务',
      description: '卫星制造、装配、测试一体化服务',
      features: [
        '精密机械加工制造',
        '电子系统集成装配',
        '卫星系统级测试',
        '质量保证体系'
      ]
    },
    {
      id: 3,
      icon: 'am-icon-satellite-dish',
      title: '运营维护服务',
      description: '卫星在轨运行监控与维护服务',
      features: [
        '7×24小时在轨监控',
        '轨道控制与机动',
        '故障诊断与处理',
        '数据接收与处理'
      ]
    }
  ],
  
  support: [
    {
      id: 1,
      icon: 'am-icon-phone',
      title: '电话支持',
      description: '专业技术团队提供电话咨询服务',
      time: '7×24小时'
    },
    {
      id: 2,
      icon: 'am-icon-envelope',
      title: '邮件支持',
      description: '通过邮件提供详细技术文档和解决方案',
      time: '24小时内回复'
    },
    {
      id: 3,
      icon: 'am-icon-users',
      title: '现场支持',
      description: '专业工程师提供现场技术支持和培训',
      time: '48小时内响应'
    }
  ]
};

// 企业统计数据
export const statisticsData = {
  achievements: [
    {
      icon: 'am-icon-users',
      number: '50+',
      label: '技术专家',
      description: '航天领域资深专家团队'
    },
    {
      icon: 'am-icon-trophy',
      number: '100+',
      label: '成功项目',
      description: '参与国家重点航天项目'
    },
    {
      icon: 'am-icon-cogs',
      number: '15+',
      label: '年技术积累',
      description: '深厚的技术研发经验'
    },
    {
      icon: 'am-icon-clock-o',
      number: '24/7',
      label: '技术支持',
      description: '全天候专业技术支持'
    }
  ],
  
  financial: {
    revenue2023: 5000,
    revenue2022: 3500,
    growthRate: 42.8,
    projectCount: 156,
    clientCount: 89
  }
};

// 联系方式数据
export const contactData = {
  company: '浙江洞一科技有限公司',
  address: '浙江省宁波市北仑区枫林路滨江装备创业园三期14幢二层',
  phone: '13221429257',
  email: 'info@dongyi-tech.com',
  website: 'www.dongyi-tech.com',
  workTime: '周一 ~ 周五, 09:00 - 18:00',
  coordinates: {
    lat: 29.9085,
    lng: 121.8415
  }
};

// 导出所有数据
export default {
  productData,
  newsData,
  exampleData,
  teamData,
  qualificationData,
  technicalData,
  satelliteOrbitData,
  slideshowData,
  serviceData,
  statisticsData,
  contactData,
  mockDelay,
  createMockResponse
}; 